import {Route} from "react-router-dom";
import React from "react";
import DandOSelectorContainer from "../components/DandOSelectorContainer";
import DandOCreationForm from "../components/DandOCreationForm";

export const DANDO_SELECTION_ROUTE =  <Route path="/dandos" exact component={DandOSelectorContainer}/>;
export const DANDO_CREATION_ROUTE =  <Route path="/dandos/create" exact component={DandOCreationForm}/>;
export const DANDO_DUPLICATION_ROUTE =  <Route path="/dandos/create/:caseId" exact component={DandOCreationForm}/>;
export const DANDO_UPDATION_ROUTE =  <Route path="/dandos/update/:dandoId" exact component={DandOCreationForm}/>;



// WEBPACK FOOTER //
// ./src/dandos/routes/routes.js